import { createAction } from 'redux-actions';

export const GetAllSeminarRequested = createAction('GET_ALL_SEMINAR_REQUESTED');
export const GetAllSeminarRequestedReceived = createAction('GET_ALL_SEMINAR_REQUESTED_RECEIVED');
export const GetAllSeminarRequestedReceivedFailure = createAction('GET_ALL_SEMINAR_REQUESTED_RECEIVED_FAILURE');
export const ClearSeminarData = createAction('CLEAR_SEMINAR_DATA');

export const GetDetailSeminarIgnoreCompanyIdRequested = createAction('GET_DETAIL_SEMINAR_IGNORE_COMPANY_ID_REQUESTED');
export const GetDetailSeminarIgnoreCompanyIdRequestedReceived = createAction('GET_DETAIL_SEMINAR_IGNORE_COMPANY_ID_REQUESTED_RECEIVED');
export const GetDetailSeminarIgnoreCompanyIdRequestedReceivedFailure = createAction('GET_DETAIL_SEMINAR_IGNORE_COMPANY_ID_REQUESTED_RECEIVED_FAILURE');
export const ClearDetailSeminarData = createAction('CLEAR_DETAIL_SEMINAR_DATA');

export const UpdateSeminarIgnoreCompanyIdRequested = createAction('UPDATE_SEMINAR_IGNORE_COMPANY_ID_REQUESTED');
export const UpdateSeminarIgnoreCompanyIdRequestedReceived = createAction('UPDATE_SEMINAR_IGNORE_COMPANY_ID_REQUESTED_RECEIVED');
export const UpdateSeminarIgnoreCompanyIdRequestedReceivedFailure = createAction('UPDATE_SEMINAR_IGNORE_COMPANY_ID_REQUESTED_RECEIVED_FAILURE');
export const ClearSeminarUpdateData = createAction('CLEAR_SEMINAR_UPDATE_DATA');

export const UpdateSeminarProgress = createAction('UPDATE_SEMINAR_PROGRESS');
